'use client'
import React from 'react'
import MyImage from '@/shared/components/myImage'
import errImage from '@/assets/images/error-images/statsNotAvailable.svg'

type ErrorPropsType = {
  error: {
    stack: string
    message: string
  }
  reset: () => void
}

export default function Error(props: ErrorPropsType) {
  console.log('Error from: series', props.error)
  return (
    <div className="w-full h-[calc(100vh_-_300px)] mx-4 my-4  flex items-center flex-col justify-center">
      <p className="text-2xl mb-6 px-4 text-center">Something Went Wrong</p>
      {/* <p className='text-xs px-4 text-center'>{props.error?.stack?.substring(props.error?.stack?.indexOf(' at ') + 3)}</p> */}
      {/* <p className='text-xs px-4 text-center'>
				{props.error?.stack.split(' at ').map((message: string) => {
					return <p key={message}>{message}</p>
				})}
			</p> */}
      <MyImage src={errImage} height={200} />
      <button className="btn-primary my-8">Try again</button>
    </div>
  )
}
